var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-spin',{attrs:{"spinning":_vm.confirmLoading}},[_c('a-form',{attrs:{"form":_vm.form,"label-col":_vm.labelCol,"wrapper-col":_vm.wrapperCol}},[_c('a-form-item',{attrs:{"label":"等级名称"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
          'name',
          {
            rules: [
              {
                required: true,
                message: '请输入等级名称,不超过100个字',
              } ],
          } ]),expression:"[\n          'name',\n          {\n            rules: [\n              {\n                required: true,\n                message: '请输入等级名称,不超过100个字',\n              },\n            ],\n          },\n        ]"}],staticStyle:{"width":"500px"},attrs:{"size":"large","max-length":100,"placeholder":"请输入等级名称,不超过100个字"}})],1),_c('a-form-item',{attrs:{"label":"会员权益"}},[_c('a-tree-select',{directives:[{name:"decorator",rawName:"v-decorator",value:([
          'ctGbRelations',
          {
            rules: [
              {
                required: true,
                message: '请选择会员权益',
              } ],
          } ]),expression:"[\n          'ctGbRelations',\n          {\n            rules: [\n              {\n                required: true,\n                message: '请选择会员权益',\n              },\n            ],\n          },\n        ]"}],ref:"ctGbRelations",staticStyle:{"width":"500px"},attrs:{"size":"large","tree-data":_vm.relationsTree,"tree-checkable":"","placeholder":"请选择会员权益"},on:{"change":_vm.onRelationsChange}})],1),_c('a-form-item',{attrs:{"label":"权限管理"}},[_c('a-tree-select',{directives:[{name:"decorator",rawName:"v-decorator",value:([
          'cmCtPermissions',
          {
            rules: [
              {
                required: true,
                message: '请选择栏目',
              } ],
          } ]),expression:"[\n          'cmCtPermissions',\n          {\n            rules: [\n              {\n                required: true,\n                message: '请选择栏目',\n              },\n            ],\n          },\n        ]"}],ref:"cmCtPermissions",staticStyle:{"width":"500px"},attrs:{"size":"large","tree-data":_vm.columnChannel,"tree-checkable":"","placeholder":"请选择栏目"},on:{"change":_vm.onChange}})],1),_c('a-form-item',{attrs:{"label":"卡种"}},[_c('member-level-card',{directives:[{name:"decorator",rawName:"v-decorator",value:([
          'ctMmGrades',
          {
            rules: [
              {
                required: true,
                message: '请填写卡种',
              } ],
          } ]),expression:"[\n          'ctMmGrades',\n          {\n            rules: [\n              {\n                required: true,\n                message: '请填写卡种',\n              },\n            ],\n          },\n        ]"}],staticStyle:{"width":"500px"},attrs:{"size":"large"}})],1),_c('a-form-item',{attrs:{"label":"icon"}},[_c('UploadImage',{attrs:{"imgUrl":_vm.iconUrl},on:{"handleFileList":_vm.handleImageList}})],1),_c('a-form-item',{attrs:{"label":"排序"}},[_c('a-input-number',{directives:[{name:"decorator",rawName:"v-decorator",value:([
          'idx',
          {
            rules: [
              {
                required: true,
                message: '请填写排序',
              } ],
          } ]),expression:"[\n          'idx',\n          {\n            rules: [\n              {\n                required: true,\n                message: '请填写排序',\n              },\n            ],\n          },\n        ]"}]})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }